<template>
    <div>
        <div>
            <canvas v-if="canvas_show"
                    id="splice_canvas"
                    :style="{width:img_width}"
            ></canvas>

            <img v-if="img_show" id="img_view" :src="img_64_url" :width="img_width"
                 :style="{position: 'absolute', left: canvas_offset_left}"/>
            <!--        left: 0,right:0, margin: 'auto'-->

            <!--        <van-button  plain size="small" type="info" round-->
            <!--                    style="position: absolute; right: 10px; "-->
            <!--                    @click="showImage"-->
            <!--        >-->
            <!--            刷新图片-->
            <!--        </van-button>-->
        </div>

        <div v-if="showTip">{{save_tip}}</div>

        <div style="display: none">
            <button @click="down">下载</button>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {ImagePreview} from 'vant';

    Vue.use(ImagePreview);

    export default {
        name: "Wp_image_splice",
        props: {
            maxWidth: { // 绘图区域宽度
                type: Number,
                default: 400
            },
            maxHeight: { // 绘图区域高度
                type: Number,
                default: 400
            },
            width: {
                type: Number,
                default: 0
            },
            img_list: {
                type: Array,
            },
            showTip: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                // 同一页面多次渲染时，用于区分元素的id
                canvas: null,
                // canvas对象
                context: {},
                // 是否处于绘制状态
                canvasMoveUse: false,
                img: new Image(),

                img_64_url: "",
                img_width: "300px",

                canvas_show: true,
                img_show: false,

                canvas_offset_left: "142px",

                save_tip: '图片优化中...',
            }
        },

        created(){
            this.$log(this.img_list)
        },
        methods: {

            makePic() {
                let img_view = document.querySelector('#img_view');
                if(img_view) {
                    img_view.src = "";
                }
                this.initImgWidth();
                this.initDraw();
                this.initImg();
            },

            /**
             * 显示图片预览
             */
            showImagePreview() {
                ImagePreview({
                    images: [
                        this.img_64_url
                    ],
                    showIndex: false
                });
            },
            initDraw() {
                // 初始化画布
                this.canvas = document.getElementById('splice_canvas');
                this.context = this.canvas.getContext('2d');
            },
            initImg() {
                let flg = false;
                this.img_list.length % 2 === 0 ? flg = false : flg = true;
                this.canvas.width = this.maxWidth;
                this.canvas.height = this.maxHeight;
                let nextY = 0;
                let count = 0;
                let lineNum = -1;
                for (let i = 0; i < this.img_list.length; i++) {
                    let img = new Image();


                    img.crossOrigin = "";
                    img.setAttribute("crossOrigin", 'Anonymous');

                    let x = 0;
                    let y = 0;
                    let w = this.maxWidth;
                    let h = this.maxHeight;
                    if (img) {
                        if (flg && i === 0) {   //奇数
                            w = this.maxWidth;
                            h = this.maxHeight;
                            lineNum = lineNum + 1;
                            nextY = nextY + h;
                        } else {  //偶数
                            count = count + 1;
                            let newLine = true;
                            count % 2 === 0 ? newLine = false : newLine = true;
                            w = this.maxWidth / 2;
                            h = this.maxHeight / 2;
                            y = nextY;
                            if (newLine) {  //新的一行
                                lineNum = lineNum + 1;
                                x = 0;
                            } else {   //不换行
                                x = this.maxWidth / 2;
                                nextY = nextY + h;
                            }
                        }
                        this.canvas.height = nextY;

                        img.onload = () => {
                            img.width = w;
                            img.height = h;
                            this.context.drawImage(img, x, y, w, h);
                            //写编号，改变图片md5
                            let timestamp = 'No.'+Date.parse(new Date());
                            this.context.fillStyle="#058";
                            this.context.fillText(timestamp,10,10);
                            this.context.stroke();
                        };

                        let _u = this.img_list[i];
                        if(this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.id){
                            this.$log("---mini---app----")
                            img.src = _u;
                        }else{
                            this.$log("---h5----")
                            this.getURLBase64(_u).then(base64 => {
                                img.src = base64;
                            });
                        }

                    }
                }


                // this.showImage();
                setTimeout(() => {
                    this.showImage();
                    this.save_tip = "长按图片保存到相册";
                }, 2000);

            },

            showImage() {
                this.img_64_url = this.canvas.toDataURL("image/png");

                //覆盖层的img到左边的距离
                this.canvas_offset_left = this.canvas.offsetLeft + "px";

                // this.canvas_show = false;
                this.img_show = true;

                // alert(this.canvas.offsetLeft)

            },


            down() {
                let imgSrc = this.canvas.toDataURL("image/png");
                this.downloadFile('img.png', imgSrc)
            },
            getURLBase64(url) {
                return new Promise((resolve, reject) => {
                    let xhr = new XMLHttpRequest();

                    xhr.open('get', url, true);
                    xhr.responseType = 'blob';
                    xhr.onload = function () {
                        if (this.status === 200) {
                            let blob = this.response;
                            let fileReader = new FileReader();
                            fileReader.onloadend = function (e) {
                                let result = e.target.result;
                                resolve(result)
                            };
                            fileReader.readAsDataURL(blob)
                        }
                    };

                    xhr.onerror = function () {
                        reject()
                    };
                    xhr.send()
                })
            },
            //下载
            downloadFile(fileName, content) {
                let aLink = document.createElement('a');
                let blob = this.base64ToBlob(content); //new Blob([content]);

                let evt = document.createEvent("HTMLEvents");
                evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
                aLink.download = fileName;
                aLink.href = URL.createObjectURL(blob);

                // aLink.dispatchEvent(evt);
                //aLink.click()
                aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));//兼容火狐
            },
            //base64转blob
            base64ToBlob(code) {
                let parts = code.split(';base64,');
                let contentType = parts[0].split(':')[1];
                let raw = window.atob(parts[1]);
                let rawLength = raw.length;

                let uInt8Array = new Uint8Array(rawLength);

                for (let i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }
                return new Blob([uInt8Array], {type: contentType});
            },

            initImgWidth() {
                if (this.width < 1) {
                    if (this.img_list && this.img_list.length > 0) {
                        let scale = 0.25;
                        if (this.img_list.length === 2) {
                            // this.img_width = "70%";
                            scale = 0.46;
                        } else if (this.img_list.length === 3) {
                            // this.img_width = "33%";
                            scale = 0.22;
                        } else if (this.img_list.length === 5) {
                            // this.img_width = "25%";
                            scale = 0.16;
                        } else if (this.img_list.length === 6) {
                            // this.img_width = "33%";
                            scale = 0.22;
                        }

                        this.img_width = (600 * scale).toString() + "px";
                    }
                } else {
                    this.img_width = this.width
                }
            },
        },
        watch: {
            img_list() {
                this.makePic();
            }
        },
        mounted: function () {
            this.makePic();
        },
    }
</script>

<style scoped>

</style>